import {MithrilComponent} from '@bitstillery/mithril'
import {titleize} from '@bitstillery/common/utils'
import {format_iso_to_date_time} from '@bitstillery/common/lib/format'
import m from '@bitstillery/mithril'

import type {GetSalesOrdersCollectionViewResponse} from '@bitstillery/common/api/fact2server'

interface CellDestinationAttrs {
    row: Pick<
        GetSalesOrdersCollectionViewResponse,
        | 'destination_location'
        | 'destination_name'
        | 'final_loading_date'
        | 'incoterm_and_location'
        | 'planned_loading_date'
        | 'warehouse_reference'
        | 'warehouse_status'
    >
}

export class CellDestination extends MithrilComponent<CellDestinationAttrs> {
    _format_date(date_time_str: string): string {
        return format_iso_to_date_time(date_time_str).replace(' 00:00:00', '').replace(',', '')
    }

    view(vnode: m.Vnode<CellDestinationAttrs>) {
        return (
            <div className='c-cell-destination td-group'>
                {vnode.attrs.row.warehouse_status && (
                    <div className='header'>
                        {`${titleize(vnode.attrs.row.warehouse_status)} ${vnode.attrs.row.warehouse_reference ? `: ${vnode.attrs.row.warehouse_reference}` : ''}`}
                    </div>
                )}

                <div className='header-subtle'>
                    {(() => {
                        if (vnode.attrs.row.destination_name) {
                            return vnode.attrs.row.destination_name
                        } else if (vnode.attrs.row.destination_location) {
                            return vnode.attrs.row.destination_location
                        }
                        return '-'
                    })()}
                </div>

                <span className='sub-details'>
                    {(() => {
                        if (vnode.attrs.row.final_loading_date) {
                            return `Final loading: ${this._format_date(vnode.attrs.row.final_loading_date)}`
                        } else if (vnode.attrs.row.planned_loading_date) {
                            return `Planned loading: ${this._format_date(vnode.attrs.row.planned_loading_date)}`
                        }
                        return undefined
                    })()}
                </span>

                <span className='sub-details'>{vnode.attrs.row.incoterm_and_location}</span>
            </div>
        )
    }
}
